import axios from '../utils/axios';

export default function rejectCourse(adminId, data) {
    return (
        axios.post('/admin/' + adminId +'/courses/course/reject',  data )
    )
}
